import { Alert, Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import * as JSTool from '../../store/JSTool';
import { getImgPath } from '../../store/JSTool';
import $ from 'jquery';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { settingActions, settingObj } from '../../store/SettingSlice';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';
import { Autoplay, EffectFade } from 'swiper/modules';
import * as APJHttp from '../../store/APJHttp';

let latestCacheAry = null;

export default function HomeNewsMobile(props) {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const settingData = useSelector(state => state.settingData);

    const [swp, setSwp] = React.useState(null);
    const [index, setIndex] = React.useState(0);
    const [dataAry, setDataAry] = React.useState([]);

    React.useEffect(() => {
        if (latestCacheAry == null) {
            APJHttp.getLatestNews(4, (res) => {
                latestCacheAry = res.data;
                setDataAry(res.data);
            }, (code, msg) => {
                dispatch(settingActions.showToast(`code ${code}: ${msg}`));
            })
        } else {
            setDataAry(latestCacheAry);
        }
    }, []);

    function indexChanged() {
        if (swp) {
            setIndex(swp.realIndex);
        }
    }

    return (
        <Stack sx={{
            width: 1,
        }}>

            <Swiper style={{
                width: '100%',
                backgroundColor: '#EBEBEB',
            }}
                loop={true}
                slidesPerView={1}
                modules={[Autoplay]}
                centeredSlides={true}
                slideToClickedSlide={true}

                autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                }}

                onActiveIndexChange={(sp) => {
                    indexChanged();
                }}

                onSwiper={(swiper) => {
                    setSwp(swiper);
                }}>

                {dataAry.map((item, index) => {
                    return <SwiperSlide key={index}><NewsItem item={item} /></SwiperSlide>
                })}

            </Swiper>

            <PageItem pageNum={[0, 1, 2, 3]} currentIndex={index} />

            {/* 更多 */}
            <Stack
                sx={{
                    width: 1,
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    alignItems: 'center',

                }}>
                <Typography
                    onClick={() => {
                        dispatch(settingActions.setNavIndex(2));
                        navigate('/newsList');
                    }}
                    sx={{
                        fontFamily: settingData.fontFM,
                        cursor: 'pointer',
                        fontSize: 14,
                    }}>
                    {settingData.langDic['lang10']}
                </Typography>

                <Box component={'img'}
                    src={getImgPath('arrow_right_black.png')}
                    sx={{
                        ml: 0.5,
                        height: '10px',
                        mr: 2,
                    }} />

            </Stack>

        </Stack>
    );
}

function NewsItem(props) {

    const navigate = useNavigate();
    const settingData = useSelector(state => state.settingData);

    function itemTap() {
        navigate(`/newsDetail?id=${props.item.id}`,
            {
                state: {
                    x: ''
                }
            });
    }

    return (
        <Stack
            onClick={itemTap}
            sx={{
                flexDirection: 'row',
                alignItems: 'center',
            }}>
            {/* 大图 */}
            <Box
                component={'img'}
                src={getImgPath(props.item.image_url)}
                sx={{
                    width: window.innerWidth * 0.6,
                    borderRadius: '4px',
                    cursor: 'pointer',
                    my: 1.5,
                    ml: 2,
                }} />

            {/* 右边 */}
            <Stack sx={{
                justifyContent: 'center',
                alignItems: 'center',
                mx: 1,
            }}>
                <Typography sx={{
                    fontFamily: 'Lexend Deca',
                    fontSize: 13
                }}>
                    {props.item.display_time}
                </Typography>

                <Typography sx={{
                    fontFamily: 'Source Han Sans CN',
                    fontSize: 9,
                    mt: 0.5,
                }}>
                    {props.item.title}
                </Typography>

                {/* 按钮 */}
                <Stack
                    sx={{
                        height: '26px',
                        bgcolor: 'black',
                        borderRadius: '4px',
                        color: 'white',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer',
                        position: 'relative',
                        flexDirection: 'row',
                        px: 1.5,
                        mt: 1,
                    }}>
                    <Typography sx={{
                        fontFamily: settingData.fontFM,
                        fontSize: 9,
                    }}>
                        {settingData.langDic['lang9']}
                    </Typography>

                    <Box component={'img'}
                        src={getImgPath('arrow_right.png')}
                        sx={{
                            ml: 1,
                            height: '9px',
                        }} />
                </Stack>

            </Stack>

        </Stack>

    );
}

function PageItem(props) {
    const settingData = useSelector(state => state.settingData);
    return (
        <Stack sx={{
            width: 1,
            bottom: 0,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            my: 1,
        }}>

            {props.pageNum.map((v, i) => {
                return <Box
                    key={v}
                    onClick={() => { }}
                    sx={{
                        cursor: 'pointer',
                        mx: 1,
                        width: '60px',
                        height: '4px',
                        borderRadius: '2px',
                        bgcolor: props.currentIndex == i ? 'black' : '#C9C9C9',
                    }} />
            })}
        </Stack>
    )
}